import { VENDOR_RECEIVED } from '../actions/GetVendor';

const initialState = {
  loading: true,
  data: {},
};

const vendor = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_RECEIVED:
      return {
        loading: false,
        data: action.vendor,
      };
  }

  return state;
};

export default vendor;

